import { useEffect, useState } from 'react';
import { languageCodes } from '../constants/constants';
import { getLanguageData } from '../utils/feedbackDataUtils';
import { PieChartCard } from './PieChartCard';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

export const LanguagePieChart = ({ data }) => {
  const [languageData, setLanguageData] = useState([]);
  
  useEffect(() => {
    const languageHash = getLanguageData(data);
    const languageData = Object.entries(languageHash).map(([key, value]) => ({
      name: languageCodes[key],
      value: value,
    }));
    setLanguageData(languageData);
  }, [data]);

  return (
    <PieChartCard
          title={'Language Preference of Responders'}
          data={languageData}
          colors={COLORS}
          innerRadius={70}
          outerRadius={100}
        />
   
  );
};
